export default {
  "info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ユーザー情報"])}
}